/** MST Timezone Countdowns */
const changeTimezone = date => {
    let changedDate = new Date(date.toLocaleString("en-US", {timeZone: "America/Denver"}))

    const diff = changedDate.getTime() - date.getTime()

    return new Date(date.getTime() - diff)
}

const useCountdown = (targetCountdown) => {

    const targetDate = new Date(targetCountdown)

    // Set the target date in MST timezone
    const countDownDate = changeTimezone(targetDate)

    // Set the state of the countdown, the target time - the current time
    let countDown = countDownDate - new Date().getTime()

    const interval = setInterval(() => {
        countDown = countDownDate - new Date().getTime()

        // calculate time left
        getReturnValues(countDown)
    }, 1000)

    function getReturnValues(countDown) {
        const days = Math.max(0, Math.floor(countDown / (1000 * 60 * 60 * 24)));
        const hours = Math.max(0, Math.floor((countDown % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)));
        const minutes = Math.max(0, Math.floor((countDown % (1000 * 60 * 60)) / (1000 * 60)));
        const seconds = Math.max(0, Math.floor((countDown % (1000 * 60)) / 1000));

        document.querySelectorAll('.js-days').forEach(item => item.innerHTML = days < 10 ? `0${days}` : `${days}`);
        document.querySelectorAll('.js-hours').forEach(item => item.innerHTML = hours < 10 ? `0${hours}` : `${hours}`);
        document.querySelectorAll('.js-minutes').forEach(item => item.innerHTML = minutes < 10 ? `0${minutes}` : `${minutes}`);
        document.querySelectorAll('.js-seconds').forEach(item => item.innerHTML = seconds < 10 ? `0${seconds}` : `${seconds}`);

        document.querySelectorAll('.js-timer').forEach(timer => timer.style.opacity = 1);

        if (days + hours + minutes <= 0) {
            clearInterval(interval);
            const currentParams = window.location.search;
            window.location.href = `https://ourhealthnaturally.com/products/our-7-ohn${currentParams}`;
        }
    }
}
document.querySelectorAll('.js-timer').forEach( (timer) => {
    const countDownTime = timer.getAttribute('data-time');
    useCountdown(countDownTime);
    console.log('countDownTime', countDownTime)
});